<template>
      <div class="xs-12 p4">
            <core-form-input
                  componentName="j-base-input-text"
                  name="code"
                  :label="$t('add_discount')"
                  v-validate="'required'"
                  v-model="form.code"
                  :validationErrors="errors"
                  @enter="handleSave"
            />

            <div class="flex xs-between mt6">
                  <j-button :isLoading="isLoading" @click="handleSave">{{ $t("save") }}</j-button>
                  <j-button @click="handleCancel" type="bordered">{{ $t("cancel") }}</j-button>
            </div>
      </div>
</template>

<script>
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JButton from "@/components/JButton"
import api from "../api/"

export default {
	name: "add-discount",
	components: {
		CoreFormInput,
		JButton
	},
	props: {
		offerId: {
			type: String
		},
		policyId: {
			type: String
		},
		productId: {
			type: Object
		},
		pricing: {
			type: Object
		}
	},
	data() {
		return {
			form: {
				code: null
			},
			isLoading: false
		}
	},
	methods: {
		async handleSave() {
			const isValid = await this.$validator.validate()
			if (!isValid) return

			if (
				this.pricing.appliedDiscounts.some(
					discount => discount.code === this.form.code
				)
			) {
				this.$store.dispatch("showError", [
					"This code has already been applied"
				])
				return
			}

			const variables = {
				policyId: this.policyId,
				offerId: this.offerId,
				updateOfferInput: {
					productId: this.productId,
					premium: {
						discountCodes: this.pricing.appliedDiscounts
							.map(discount => discount.code)
							.concat(this.form.code)
					}
				}
			}

			// Call api
			this.isLoading = true
			const res = await api.updateOffer(variables)

			const quote = await api.checkOffer({
				where: { id: this.policyId }
			})
			this.isLoading = false

			// Check errors
			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			this.isLoading = false

			// Check errors
			if (quote.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			const appliedDiscounts = quote.data?.policies?.list
				?.find(policy =>
					policy.offers.find(
						offer => offer.id === this.offerId
					)
				)
				?.offers?.find(offer => offer.id === this.offerId)
				?.premium?.appliedDiscounts

			// if applied discounts is not found, show error
			if (
				!appliedDiscounts?.some(
					discount => discount.code === this.form.code
				)
			) {
				this.$store.dispatch("showError", [
					`The discount code ${
						this.form.code
					} is invalid and was not applied`
				])
				return
			}

			// Emit
			this.$emit("created")
		},
		handleCancel() {
			this.$emit("cancelled")
		}
	}
}
</script>

<style>
</style>
